import React from "react";
import { EnrollmentActivitySummaryTabsUnit } from "./enrollment-activity-summary-tabs-unit";

export function EnrollmentActivitySummaryPage(): JSX.Element {
  return <EnrollmentActivitySummaryTabsUnit />;
}
